const HeaderType = {
  Success: "Success",
  Info: "Info",
  Warning: "Warning",
  Error: "Error"
};

/**
 * Generated bundle index. Do not edit.
 */

export { HeaderType };
